import React from "react";
import "../../assets/css/gallery.css";
import { motion } from "framer-motion";
import Group from '../../assets/images/Group2.jpeg'
import Corporative from '../../assets/images/corpo.jpeg'
import Hotel from '../../assets/images/hotel.jpeg'
import Adventure from '../../assets/images/Adventure .jpeg'
import Religious  from '../../assets/images/Religious2.jpeg'

export default function Gallery() {

  const gallery = [
    {
      title: "Group Tour Memories",
      desc: "Unforgettable journeys with friends and families.",
       img: Group

    },
    {
      title: "Corporate Events",
      desc: "Professional events managed with perfection.",
      img: Corporative  },
    {
      title: "Hotel Stays",
      desc: "Comfortable and premium accommodations worldwide.",
      img: Hotel
    },
    {
      title: "Adventure Trips",
      desc: "Thrilling experiences full of excitement.",
      img: Adventure
    },
    {
      title: "Cultural & Religious Visits",
      desc: "Explore traditions and spiritual destinations.",
      img: Religious 
    }
  ];

  return (
    <section className="galleryPro">

      {/* Heading */}
      <motion.h2
        className="gallery-heading"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
      >
        Explore Our <span>Travel Moments</span>
      </motion.h2>

      <div className="gallery-wrapper">

        {/* LEFT TEXT LIST */}
        <div className="gallery-left">
          {gallery.map((item, i) => (
            <motion.div
              className="gallery-item"
              key={i}
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
            >
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* RIGHT IMAGE STACK */}
        <div className="gallery-right">
          {gallery.map((item, i) => (
            <motion.img
              key={i}
              src={item.img}
              alt={item.title}
              className="gallery-img"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: i * 0.2 }}
            />
          ))}
        </div>

      </div>

    </section>
  );
}